module.exports = __webpack_public_path__ + "static/media/elliot_ai_logo.75c3b53a.svg";